if (!customElements.get('lulla-monthly-refills')) {
  customElements.define('lulla-monthly-refills', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.button = this.querySelector('button');
      this.error = this.querySelector('[role="alert"]');
      this.button.addEventListener('click', () => this.checkout());
      this.onChange = () => this.refresh();
      this.scope = this.closest('product-info') || this.closest('.shopify-section');
      this.scope?.addEventListener('change', this.onChange);
      this.observer = new MutationObserver(() => this.refresh());
      if (this.scope) this.observer.observe(this.scope, { subtree: true, childList: true, attributes: true, attributeFilter: ['value', 'disabled'] });
      this.load();
    }
    disconnectedCallback() {
      this.scope?.removeEventListener('change', this.onChange);
      this.observer?.disconnect();
      this.initialized = false;
    }
    async json(url, options) {
      const response = await fetch(url, options);
      const data = await response.json();
      if (!response.ok || data.status >= 400) throw new Error('Request failed');
      return data;
    }
    async load() {
      try {
        const url = new URL('https://repeat.is/api/v1/shopify_variants/');
        url.searchParams.set('product_types', 'SUBSCRIPTION');
        url.searchParams.set('variant_ids', JSON.parse(this.dataset.variants).join(','));
        this.products = await this.json(url, { headers: { 'x-api-key': window.repeatSettings.apiKey } });
        if (!Array.isArray(this.products)) throw new Error('Invalid product data');
        this.refresh();
      } catch (_) {
        this.showError();
      }
    }
    selection() {
      const form = document.getElementById(this.dataset.formId);
      const variant = form?.querySelector('[name="id"]');
      const product = this.products?.find(item => String(item.shopify_variant_id) === variant?.value);
      const interval = product?.interval_combinations?.find(item => /^(month|months)$/i.test(item.type) && (!item.count_options || item.count_options.some(count => Number(count) === 1)));
      const price = product?.prices?.find(item => item.currency.currency_code === this.dataset.currency);
      const quantity = form ? Number(new FormData(form).get('quantity') || 1) : 0;
      const submit = form?.querySelector('[name="add"]');
      return { product, interval, price, quantity, available: !!variant && !variant.disabled && !!submit && !submit.disabled };
    }
    refresh() {
      if (this.busy || !this.products) return;
      const { product, interval, price, available } = this.selection();
      const ready = available && !!product?.repeat_uuid && !!interval && Number(price?.amount) > 0;
      if (this.button.disabled === ready) this.button.disabled = !ready;
      const amount = price && new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(Number(price.amount));
      const label = amount ? `${this.dataset.label} - ${amount}${this.dataset.currency === 'ISK' ? 'kr' : ' ' + this.dataset.currency}` : this.dataset.label;
      if (this.button.textContent !== label) this.button.textContent = label;
      if (!ready && available) this.showError();
    }
    showError() {
      if (this.error.textContent !== this.dataset.error) this.error.textContent = this.dataset.error;
      this.error.hidden = false;
    }
    async checkout() {
      if (this.busy || this.button.disabled) return;
      const { product, interval, price, quantity, available } = this.selection();
      if (!available || !product || !interval || !price || !Number.isInteger(quantity) || quantity < 1) {
        this.showError();
        return;
      }
      this.busy = true;
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      this.button.textContent = this.dataset.loading;
      this.error.hidden = true;
      try {
        await this.json(this.dataset.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{
            id: product.shopify_variant_id, quantity,
            properties: {
              Frequency: '1 month apart',
              _repeat_product: product.repeat_uuid,
              _repeat_interval_count: 1,
              _repeat_interval_type: interval.type
            }
          }] })
        });
        this.added = true;
        const cart = await this.json(this.dataset.root + 'cart.js');
        const items = cart.items.filter(item => item.properties?._repeat_product);
        if (!cart.token || !items.length) throw new Error('Missing subscription cart');
        const url = new URL('https://repeat.is/repeat_checkout/8e901d33-fa9e-4a08-ac29-ae19ee0cc755/');
        url.searchParams.set('currency', cart.currency || this.dataset.currency);
        url.searchParams.set('language', this.dataset.language);
        url.searchParams.set('shopify_cart_token', cart.token);
        items.forEach((item, index) => {
          url.searchParams.set(`products.${index}.uuid`, item.properties._repeat_product);
          url.searchParams.set(`products.${index}.quantity`, item.quantity);
          url.searchParams.set(`products.${index}.interval_count`, item.properties._repeat_interval_count);
          url.searchParams.set(`products.${index}.interval_type`, item.properties._repeat_interval_type);
        });
        window.location.assign(url.href);
      } catch (_) {
        this.showError();
        this.busy = !!this.added;
        if (this.added) this.button.textContent = this.dataset.error;
        this.button.removeAttribute('aria-busy');
        this.refresh();
      }
    }
  });
}
